import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';
import { BrandIconComponent } from './brand-icon/brand-icon.component';
import { SocialLabelPipe } from './brand-icon/social-label.pipe';
import { ErrorStateComponent } from './state/error-state.component';
import { PagerComponent } from './pager/pager.component';
import { EmptyStateComponent } from './state/empty-state.component';
import { FormFieldComponent } from './form-field/form-field.component';
import { MediaTileComponent } from './media-tile/media-tile.component';
import { ShareComponent } from './share/share.component';
import { PageSectionsComponent } from './section/section.component';
import { NewsCardComponent } from './news-card/news-card.component';

/**
 * The shared UI primitives. Page modules import this module rather than
 * reproducing the markup inline, which is what the two language trees had been
 * doing: the pager alone was the same 24 lines in 17 templates.
 */
@NgModule({
  declarations: [BrandIconComponent, SocialLabelPipe, ErrorStateComponent, EmptyStateComponent, PagerComponent, FormFieldComponent, MediaTileComponent, ShareComponent, PageSectionsComponent, NewsCardComponent],
  // ShareButtons is imported without withConfig(): the page modules that use
  // the share row already call withConfig, and calling it twice would provide
  // the config service a second time.
  // RouterModule for routerLink in news-card: the copies it replaces used a
  // raw href on the image, which forced a full page reload.
  imports: [CommonModule, RouterModule, ShareButtonsModule, ShareIconsModule],
  exports: [BrandIconComponent, SocialLabelPipe, ErrorStateComponent, EmptyStateComponent, PagerComponent, FormFieldComponent, MediaTileComponent, ShareComponent, PageSectionsComponent, NewsCardComponent]
})
export class SharedWidgetsModule { }
